import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import profile from "../Assets/profile.png";
import owener from "../Assets/owener.png";
import { BASE_URL } from "../Function/Base";
import { useAuth } from "../Function/AuthProvider";
import { useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import SignOut from "./SignOut";
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
function TopNav(props) {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState(null);
  const [NOTIFY, setNotify] = useState(null);
  const auth = useAuth();
  axios.defaults.headers.common["Authorization"] = `Bearer ${auth.token}`;
  const location = useLocation();
  const { pathname } = location;
  useEffect(() => {
    if (props?.compusData !== "" && props.compusData != null) {
      const campusId = parseInt(props?.selectedValue); // replace with the campusID you want to filter by
      const filteredContents =
        props?.compusData != null &&
        props?.compusData?.Active_Campuses?.filter(
          (content) => content?.Welcome_Section_Contents?.campusID === campusId
        );
      const titles =
        props?.compusData != null &&
        filteredContents?.map(
          (content) => content?.Welcome_Section_Contents?.campusName
        );
      setTitle(titles);
    }
  }, []);
  const instance = axios.create({
    baseURL: BASE_URL,
    retry: {
      maxRetries: 3,
      delay: 6000,
    },
  });
  useEffect(() => {
    const interval = setInterval(() => {
      instance
        .post(`${BASE_URL}/api/get-notifications?`)
        .then(function (response) {
          if (response.data?.status === 200) {
            setNotify(response.data);
          } else if (response?.status === 404) {
          }
        })
        .catch(function (error) {
          // handle error
        })
        .finally(function () {
          // always executed
        });
    }, 10000);
    return () => clearInterval(interval);
  }, [open, auth.APIloading]);

  async function Viewall() {
    setOpen(!open);

    await axios
      .post(`${BASE_URL}/api/mark-all-notifications`)
      .then(function (response) {
        if (response.data.status === 200) {
          // auth.openMessage(response.data?.message,'success',1);
        }
      })
      .catch(function (error) {
        auth.openMessage(error, "success", 1);
      });
  }
  async function Seeall() {
    await axios
      .post(`${BASE_URL}/api/mark-all-notifications`)
      .then(function (response) {
        if (response.data.status === 200) {
          auth.openMessage(response.data?.message, "success", 1);
        }
      })
      .catch(function (error) {
        auth.openMessage(error, "success", 1);
      });
  }
  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 24,
        color:'#AF20F2'
      }}
      spin
    />
  );
  const [loading,setLoading]=useState(false);
  async function handleUncheck(isSeen) {
    await axios
      .post(`${BASE_URL}/api/mark-notification?notificationID=${isSeen}`)
      .then(function (response) {
        if (response.data.status === 200) {
        }else{

        }
      })
      .catch(function (error) {});
  }
  // output the titles of the filtered contents
  const Navigate = useNavigate();

  const post = async () => {
    const url = `${BASE_URL}/api/create-new-campus`;
    setLoading(!loading)
    try {
      const response = await axios.post(url);

      if (response?.data.status === 200) {
        setLoading(false)
        Cookies.set(
          "campus",
          response?.data.campusCreated.About_Section_Contents.campusID
        );
        
        // console.log(response.data?.campusCreated)
        // Navigate('/newPage',{state:{campusID:response?.data.campusID,page:response?.data.campusCreated}});
      {!loading&& Navigate("/newPage", {
          state: {
            campusID:
              response?.data.campusCreated.About_Section_Contents.campusID,
            page: response.data?.campusCreated,
            ROUTE: "create",
          },
        });
      }
        auth.APIloading();
       
      }else{
setLoading(!loading)
      }
    } catch (error) {
      auth.openMessage(error, "error", 1);
      setLoading(!loading)
    }
  };
  return (
    <div
      className={
        props.isDarkMode
          ? "dark topNav shadow-md "
          : "topNav shadow-md bg-[#FFFFFF] "
      }
    >
      {auth.contextHolder}
      <div className="w-full h-full flex items-center dark:bg-[#171717] dark:text-gray-500">
        <div className="w-full">
          <div className="flex justify-between items-center">
            <div
              onClick={props.onclick}
              className="md:hidden w-full flex mt-[-10px] md:justify-end h-[60px] items-center"
            >
              <svg
                className=" mt-[20px]"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M11 26H29V24H11V26ZM11 21H29V19H11V21ZM11 14V16H29V14H11Z"
                  fill="black"
                />
              </svg>
            </div>
            <h2 className="md:ml-[51px] lg:ml-[51px] ml-[5px]  dark:bg-[#171717] dark:text-gray-500">
              {" "}
              {pathname.slice(1)}
            </h2>
            <div className="flex  gap-4 items-center justify-center mr-[44px]">
              <div className="flex gap-4 items-center dark:bg-[#171717] dark:text-gray-500">
                {/* {auth.isDarkMode===true? */}
                {/* // <svg onClick={()=>auth.toggleDarkMode('light')} width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      // <rect width="40" height="40" rx="5" fill="#F8F4F4"/>
      // <path d="M20 24C20.8333 24 21.5417 23.7083 22.125 23.125C22.7083 22.5417 23 21.8333 23 21C23 20.1667 22.7083 19.4583 22.125 18.875C21.5417 18.2917 20.8333 18 20 18C19.1667 18 18.4583 18.2917 17.875 18.875C17.2917 19.4583 17 20.1667 17 21C17 21.8333 17.2917 22.5417 17.875 23.125C18.4583 23.7083 19.1667 24 20 24ZM20 26C18.6167 26 17.4373 25.5123 16.462 24.537C15.4867 23.5617 14.9993 22.3827 15 21C15 19.6167 15.4877 18.4373 16.463 17.462C17.4383 16.4867 18.6173 15.9993 20 16C21.3833 16 22.5627 16.4877 23.538 17.463C24.5133 18.4383 25.0007 19.6173 25 21C25 22.3833 24.5123 23.5627 23.537 24.538C22.5617 25.5133 21.3827 26.0007 20 26ZM10 22C9.71667 22 9.479 21.904 9.287 21.712C9.095 21.52 8.99934 21.2827 9 21C9 20.7167 9.096 20.479 9.288 20.287C9.48 20.095 9.71734 19.9993 10 20H12C12.2833 20 12.521 20.096 12.713 20.288C12.905 20.48 13.0007 20.7173 13 21C13 21.2833 12.904 21.521 12.712 21.713C12.52 21.905 12.2827 22.0007 12 22H10ZM28 22C27.7167 22 27.479 21.904 27.287 21.712C27.095 21.52 26.9993 21.2827 27 21C27 20.7167 27.096 20.479 27.288 20.287C27.48 20.095 27.7173 19.9993 28 20H30C30.2833 20 30.521 20.096 30.713 20.288C30.905 20.48 31.0007 20.7173 31 21C31 21.2833 30.904 21.521 30.712 21.713C30.52 21.905 30.2827 22.0007 30 22H28ZM20 14C19.7167 14 19.479 13.904 19.287 13.712C19.095 13.52 18.9993 13.2827 19 13V11C19 10.7167 19.096 10.479 19.288 10.287C19.48 10.095 19.7173 9.99934 20 10C20.2833 10 20.521 10.096 20.713 10.288C20.905 10.48 21.0007 10.7173 21 11V13C21 13.2833 20.904 13.521 20.712 13.713C20.52 13.905 20.2827 14.0007 20 14ZM20 32C19.7167 32 19.479 31.904 19.287 31.712C19.095 31.52 18.9993 31.2827 19 31V29C19 28.7167 19.096 28.479 19.288 28.287C19.48 28.095 19.7173 27.9993 20 28C20.2833 28 20.521 28.096 20.713 28.288C20.905 28.48 21.0007 28.7173 21 29V31C21 31.2833 20.904 31.521 20.712 31.713C20.52 31.905 20.2827 32.0007 20 32ZM13.65 16.05L12.575 15C12.375 14.8167 12.279 14.5833 12.287 14.3C12.295 14.0167 12.391 13.775 12.575 13.575C12.775 13.375 13.0167 13.275 13.3 13.275C13.5833 13.275 13.8167 13.375 14 13.575L15.05 14.65C15.2333 14.85 15.325 15.0833 15.325 15.35C15.325 15.6167 15.2333 15.85 15.05 16.05C14.8667 16.25 14.6377 16.346 14.363 16.338C14.0883 16.33 13.8507 16.234 13.65 16.05ZM26 28.425L24.95 27.35C24.7667 27.15 24.675 26.9123 24.675 26.637C24.675 26.3617 24.7667 26.1327 24.95 25.95C25.1333 25.75 25.3627 25.6543 25.638 25.663C25.9133 25.6717 26.1507 25.7673 26.35 25.95L27.425 27C27.625 27.1833 27.721 27.4167 27.713 27.7C27.705 27.9833 27.609 28.225 27.425 28.425C27.225 28.625 26.9833 28.725 26.7 28.725C26.4167 28.725 26.1833 28.625 26 28.425ZM24.95 16.05C24.75 15.8667 24.654 15.6377 24.662 15.363C24.67 15.0883 24.766 14.8507 24.95 14.65L26 13.575C26.1833 13.375 26.4167 13.279 26.7 13.287C26.9833 13.295 27.225 13.391 27.425 13.575C27.625 13.775 27.725 14.0167 27.725 14.3C27.725 14.5833 27.625 14.8167 27.425 15L26.35 16.05C26.15 16.2333 25.9167 16.325 25.65 16.325C25.3833 16.325 25.15 16.2333 24.95 16.05ZM12.575 28.425C12.375 28.225 12.275 27.9833 12.275 27.7C12.275 27.4167 12.375 27.1833 12.575 27L13.65 25.95C13.85 25.7667 14.0873 25.675 14.362 25.675C14.6367 25.675 14.866 25.7667 15.05 25.95C15.25 26.1333 15.346 26.3627 15.338 26.638C15.33 26.9133 15.234 27.1507 15.05 27.35L14 28.425C13.8167 28.625 13.5833 28.721 13.3 28.713C13.0167 28.705 12.775 28.609 12.575 28.425Z" fill="black"/>
      // </svg> */}

                {/* : */}
                {/* // <svg onClick={()=>auth.toggleDarkMode('dark')} width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      // <rect width="40" height="40" rx="5" fill="#F8F4F4"/>
      // <path d="M21.1 31C19.7 31 18.3873 30.7333 17.162 30.2C15.9373 29.6667 14.871 28.946 13.963 28.038C13.0543 27.1293 12.3333 26.0623 11.8 24.837C11.2667 23.6123 11 22.3 11 20.9C11 18.4667 11.775 16.3207 13.325 14.462C14.875 12.604 16.85 11.45 19.25 11C18.95 12.65 19.0417 14.2623 19.525 15.837C20.0083 17.4123 20.8417 18.7917 22.025 19.975C23.2083 21.1583 24.5877 21.9917 26.163 22.475C27.7377 22.9583 29.35 23.05 31 22.75C30.5667 25.15 29.4167 27.125 27.55 28.675C25.6833 30.225 23.5333 31 21.1 31Z" fill="#455A64"/>
      // </svg> */}
                {/* } */}

                <div className="pointer-events-auto lg:w-auto w-[150px]">
                {loading===true? <Spin indicator={antIcon} />
            : 
                  <p
                    className={`bg-gradient-to-r pointer-events-auto from-indigo-500 via-purple-500 to-pink-500 text-white cursor-pointer  font-semibold text-[10px] text-center py-1  rounded-md mx-1 md:mx-4 my-2 lg:px-4`}
                    onClick={post}
                  >
                   
                     Create New Page
                 
    
                  </p>
                  }
                </div>

                <button
                  onClick={() => Viewall()}
                  type="button"
                  className="relative inline-flex items-center p-1 text-sm font-medium text-center text-white  rounded-lg hover:bg-[#F8F4F4] focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                >
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20.6286 15.9989C20.5508 15.9052 20.4744 15.8114 20.3994 15.7209C19.3682 14.4736 18.7443 13.7208 18.7443 10.1897C18.7443 8.36156 18.3069 6.86156 17.4449 5.73656C16.8093 4.90547 15.9501 4.275 14.8176 3.80906C14.803 3.80096 14.79 3.79032 14.7791 3.77766C14.3718 2.41359 13.2571 1.5 11.9999 1.5C10.7427 1.5 9.62849 2.41359 9.22115 3.77625C9.21027 3.78845 9.19744 3.79875 9.18318 3.80672C6.54036 4.89469 5.25599 6.98203 5.25599 10.1883C5.25599 13.7208 4.63302 14.4736 3.60083 15.7195C3.52583 15.81 3.44943 15.9019 3.37161 15.9975C3.17061 16.2399 3.04326 16.5348 3.00464 16.8473C2.96601 17.1598 3.01772 17.4769 3.15365 17.7609C3.44286 18.3703 4.05927 18.7486 4.76286 18.7486H19.2421C19.9424 18.7486 20.5546 18.3708 20.8447 17.7642C20.9813 17.4801 21.0335 17.1628 20.9952 16.8499C20.9569 16.537 20.8297 16.2417 20.6286 15.9989ZM11.9999 22.5C12.6773 22.4995 13.3418 22.3156 13.9232 21.9679C14.5045 21.6202 14.9809 21.1217 15.3018 20.5252C15.3169 20.4966 15.3244 20.4646 15.3234 20.4322C15.3225 20.3999 15.3133 20.3684 15.2966 20.3407C15.2799 20.313 15.2563 20.2901 15.2281 20.2742C15.2 20.2583 15.1682 20.25 15.1358 20.25H8.8649C8.83252 20.2499 8.80066 20.2582 8.77243 20.274C8.7442 20.2899 8.72055 20.3128 8.7038 20.3405C8.68704 20.3682 8.67774 20.3997 8.67682 20.4321C8.67588 20.4645 8.68335 20.4965 8.69849 20.5252C9.01936 21.1216 9.49567 21.6201 10.0769 21.9678C10.6581 22.3155 11.3226 22.4994 11.9999 22.5Z"
                      fill="#455A64"
                    />
                  </svg>
                  <span className="sr-only">Notifications</span>
                  {NOTIFY != null &&
                  NOTIFY != "undefined" &&
                  NOTIFY?.total_unread_notifications != 0 ? (
                    <div className="absolute inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-white bg-red-500 border-2 border-white rounded-full -top-2 -right-2 dark:border-gray-900">
                      {NOTIFY?.total_unread_notifications != null
                        ? NOTIFY?.total_unread_notifications
                        : null}
                    </div>
                  ) : (
                    ""
                  )}
                </button>
                {/* Dropdown Notifications  */}
                {open && (
                  <div
                    className="fixed top-0 right-0 w-screen h-screen "
                    onClick={() => setOpen(!open)}
                  >
                    <div className="flex justify-right absolute top-20 right-5">
                      <div
                        id="dropdownNotification"
                        className="z-20  w-full  max-w-sm bg-white divide-y divide-gray-100 rounded-lg shadow dark:bg-gray-800 dark:divide-gray-700"
                        aria-labelledby="dropdownNotificationButton"
                      >
                        <div className="block flex justify-between text-sm px-4 py-2 font-medium text-center text-gray-700 rounded-t-lg bg-gray-50 dark:bg-gray-800 dark:text-white">
                          Notifications
                          <button
                            onClick={() => Seeall()}
                            className="bg-purple-500 py-1 cursor-pointer px-2 rounded-sm text-xs text-white "
                          >
                            Mark all as read
                          </button>
                        </div>
                        <div className="divide-y divide-gray-100 overflow-y  h-[500px] dark:divide-gray-700 flex flex-col ">
                          {NOTIFY?.notifications != null &&
                          NOTIFY?.notifications != "undefined" ? (
                            <>
                              {NOTIFY?.notifications.map(
                                ({ id, deliveredTime, isSeen, message }) => (
                                  <div
                                    key={id}
                                    onClick={() => handleUncheck(id)}
                                    className={`${
                                      isSeen != 0
                                        ? " relative flex px-4 py-3 hover:bg-gray-100 dark:hover:bg-gray-700"
                                        : " bg-green-200 relative flex px-4 py-3 hover:bg-gray-100 dark:hover:bg-gray-700"
                                    }`}
                                  >
                                    <div className="flex-shrink-0">
                                      <img
                                        className="rounded-full w-11 h-11"
                                        src={owener}
                                        alt="Leslie image"
                                      />
                                      <div className="absolute flex items-center justify-center w-5 h-5 ml-6 -mt-5 bg-green-400 border border-white rounded-full dark:border-gray-800">
                                        <svg
                                          className="w-3 h-3 text-white"
                                          aria-hidden="true"
                                          fill="currentColor"
                                          viewBox="0 0 20 20"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            d="M18 13V5a2 2 0 00-2-2H4a2 2 0 00-2 2v8a2 2 0 002 2h3l3 3 3-3h3a2 2 0 002-2zM5 7a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1zm1 3a1 1 0 100 2h3a1 1 0 100-2H6z"
                                            clipRule="evenodd"
                                          ></path>
                                        </svg>
                                      </div>
                                    </div>
                                    <div className="w-full pl-3">
                                      <div className="text-gray-500 text-sm mb-1.5 dark:text-gray-400">
                                        <span className="font-semibold text-gray-900 dark:text-white"></span>{" "}
                                        <span
                                          className="font-medium text-blue-500"
                                         
                                        ></span>{" "}
                                        {message}
                                      </div>
                                      <div className="text-xs text-blue-600 dark:text-blue-500">
                                        {deliveredTime}
                                      </div>
                                    </div>
                                  </div>
                                )
                              )}
                            </>
                          ) : (
                            <p className="p-4 text-am">Empty</p>
                          )}
                        </div>
                        <div
                         
                          className="block py-2 text-sm font-medium text-center text-gray-900 rounded-b-lg bg-gray-50 hover:bg-gray-100 dark:bg-gray-800 dark:hover:bg-gray-700 dark:text-white"
                        >
                          <div className="inline-flex items-center ">
                            {/* <svg class="w-4 h-4 mr-2 text-gray-500 dark:text-gray-400" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10 12a2 2 0 100-4 2 2 0 000 4z"></path><path fill-rule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clip-rule="evenodd"></path></svg>
        View all */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* <Link to='/profile'> */}
                <img
                  onClick={() => auth.setSeting(!auth.openSeting)}
                  src={
                    props.PROFILE != null &&
                    props.PROFILE != "undefined" &&
                    props.PROFILE?.profilePicture != ""
                      ? `${BASE_URL}/` + props.PROFILE.profilePicture
                      : owener
                  }
                  className="w-[40px] h-[40px]  rounded-full mt-0 dark:bg-[#fff] dark:text-gray-500"
                  alt="profile"
                />
                {/* </Link> */}
                {/* list menu  */}
                {auth.openSeting && (
                  <div
                    className="fixed top-0 right-0 w-screen h-screen"
                    onClick={() => auth.setSeting(!auth.openSeting)}
                  >
                    <div
                      className={
                        auth.openSeting !== false
                          ? " flex justify-right absolute top-20 right-5"
                          : "hidden  justify-right absolute top-20 right-5"
                      }
                    >
                      <div
                        id="dropdownNotification"
                        className="z-20  w-full max-w-sm bg-white divide-y divide-gray-100 rounded-lg shadow dark:bg-gray-800 dark:divide-gray-700"
                        aria-labelledby="dropdownNotificationButton"
                      >
                        <div className="block text-sm px-4 py-2 font-medium text-center text-gray-700 rounded-t-lg bg-gray-50 dark:bg-gray-800 dark:text-white">
                          Main Menu
                        </div>
                        <div>
                          {/* <div className='pointer-events-auto'>
  <p className={`bg-gradient-to-r pointer-events-auto from-indigo-500 via-purple-500 to-pink-500 text-white cursor-pointer  font-semibold text-[10px] text-center py-1  rounded-md mx-4 my-2 px-4`} onClick={post}> Create</p>
</div> */}
                          {/* {props.compusData!==""&&props.compusData.Active_Campuses!=null&&props.compusData!='undefined'&&props.compusData.Active_Campuses.map((data,index)=>( 
   <div key={index}>
  
   <p className={`${auth.selectCAMPUS==data.Welcome_Section_Contents.campusID?'bg-purple-400 text-white  font-semibold':''} text-[10px] text-center py-1 bg-purple-300  text-black rounded-md mx-4 my-2 px-4`} onClick={()=>props.HandleChange(data.Welcome_Section_Contents.campusID)}>{data.Welcome_Section_Contents.fellowshipName    }</p>
</div>
))} */}
                        </div>

                        <SignOut className="flex justify-center " />
                        <div
                        
                          className="block py-2 text-sm font-medium text-center text-gray-900 rounded-b-lg bg-gray-50 hover:bg-gray-100 dark:bg-gray-800 dark:hover:bg-gray-700 dark:text-white"
                        >
                          <Link
                            onClick={() => auth.setSeting(!auth.openSeting)}
                            to="/profile"
                          >
                            <div className="inline-flex items-center gap-4 justify-center p-4 ">
                              <svg
                                width="13"
                                height="15"
                                viewBox="0 0 43 45"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M42.4322 28.2199L39.1116 25.4072C39.2688 24.4529 39.3499 23.4785 39.3499 22.5041C39.3499 21.5297 39.2688 20.5553 39.1116 19.601L42.4322 16.7883C42.6827 16.5758 42.8619 16.2929 42.9461 15.9771C43.0304 15.6613 43.0155 15.3276 42.9037 15.0203L42.858 14.8897C41.9439 12.3584 40.575 10.0119 38.8176 7.96344L38.7264 7.85797C38.5132 7.60961 38.229 7.43107 37.9114 7.34589C37.5937 7.26072 37.2575 7.27289 36.9469 7.38081L32.8254 8.83236C31.3045 7.59679 29.6062 6.62239 27.771 5.93931L26.9751 1.67004C26.9151 1.3488 26.7578 1.05327 26.5242 0.822702C26.2905 0.592138 25.9916 0.437458 25.6672 0.379212L25.5303 0.354098C22.8891 -0.118033 20.1109 -0.118033 17.4697 0.354098L17.3328 0.379212C17.0084 0.437458 16.7095 0.592138 16.4758 0.822702C16.2422 1.05327 16.0849 1.3488 16.0249 1.67004L15.2239 5.9594C13.4034 6.64262 11.708 7.6165 10.205 8.84241L6.05306 7.38081C5.74263 7.27203 5.40614 7.25942 5.0883 7.34465C4.77046 7.42988 4.48632 7.60891 4.27365 7.85797L4.18239 7.96344C2.42704 10.0133 1.05841 12.3595 0.141958 14.8897L0.0963318 15.0203C-0.131798 15.6481 0.0557754 16.3513 0.567801 16.7883L3.92892 19.6311C3.77176 20.5754 3.69572 21.5397 3.69572 22.499C3.69572 23.4634 3.77176 24.4278 3.92892 25.367L0.567801 28.2098C0.317343 28.4223 0.138087 28.7052 0.0538691 29.021C-0.0303487 29.3368 -0.0155382 29.6705 0.0963318 29.9778L0.141958 30.1084C1.05955 32.6398 2.41819 34.9754 4.18239 37.0347L4.27365 37.1401C4.48684 37.3885 4.77099 37.567 5.08864 37.6522C5.40629 37.7374 5.74253 37.7252 6.05306 37.6173L10.205 36.1557C11.7158 37.3862 13.4039 38.3606 15.2239 39.0387L16.0249 43.3281C16.0849 43.6493 16.2422 43.9448 16.4758 44.1754C16.7095 44.406 17.0084 44.5606 17.3328 44.6189L17.4697 44.644C20.1352 45.1187 22.8648 45.1187 25.5303 44.644L25.6672 44.6189C25.9916 44.5606 26.2905 44.406 26.5242 44.1754C26.7578 43.9448 26.9151 43.6493 26.9751 43.3281L27.771 39.0588C29.6055 38.3775 31.3134 37.3999 32.8254 36.1657L36.9469 37.6173C37.2574 37.7261 37.5939 37.7387 37.9117 37.6535C38.2295 37.5682 38.5137 37.3892 38.7264 37.1401L38.8176 37.0347C40.5818 34.9703 41.9405 32.6398 42.858 30.1084L42.9037 29.9778C43.1318 29.36 42.9442 28.6568 42.4322 28.2199ZM35.5123 20.1936C35.639 20.9521 35.7049 21.7306 35.7049 22.5091C35.7049 23.2876 35.639 24.0661 35.5123 24.8245L35.1777 26.8386L38.9646 30.0481C38.3905 31.3585 37.6659 32.5989 36.805 33.7448L32.1004 32.0924L30.5086 33.3882C29.297 34.3726 27.9485 35.1461 26.4884 35.6886L24.5569 36.4068L23.6495 41.2788C22.2177 41.4395 20.7722 41.4395 19.3404 41.2788L18.4329 36.3968L16.5166 35.6685C15.0718 35.126 13.7284 34.3526 12.5269 33.3731L10.935 32.0723L6.20008 33.7398C5.33825 32.5896 4.61838 31.349 4.04045 30.0431L7.86796 26.8035L7.53844 24.7944C7.41677 24.046 7.35087 23.2725 7.35087 22.5091C7.35087 21.7406 7.4117 20.9722 7.53844 20.2238L7.86796 18.2147L4.04045 14.9751C4.61331 13.6642 5.33825 12.4286 6.20008 11.2784L10.935 12.9459L12.5269 11.6451C13.7284 10.6656 15.0718 9.89215 16.5166 9.3497L18.438 8.63146L19.3454 3.74942C20.77 3.5887 22.2249 3.5887 23.6546 3.74942L24.562 8.62141L26.4935 9.33965C27.9485 9.8821 29.302 10.6556 30.5137 11.64L32.1055 12.9359L36.8101 11.2834C37.6719 12.4336 38.3918 13.6742 38.9697 14.9801L35.1827 18.1896L35.5123 20.1936ZM21.5051 13.1669C16.5775 13.1669 12.5827 17.1248 12.5827 22.0068C12.5827 26.8889 16.5775 30.8467 21.5051 30.8467C26.4327 30.8467 30.4275 26.8889 30.4275 22.0068C30.4275 17.1248 26.4327 13.1669 21.5051 13.1669ZM25.5202 25.9848C24.9935 26.508 24.3677 26.923 23.6786 27.2057C22.9896 27.4884 22.2509 27.6334 21.5051 27.6322C19.9893 27.6322 18.5647 27.0446 17.49 25.9848C16.9619 25.463 16.5431 24.843 16.2577 24.1603C15.9723 23.4776 15.826 22.7457 15.8272 22.0068C15.8272 20.505 16.4203 19.0937 17.49 18.0289C18.5647 16.9641 19.9893 16.3814 21.5051 16.3814C23.0209 16.3814 24.4454 16.9641 25.5202 18.0289C26.0483 18.5506 26.4671 19.1707 26.7525 19.8534C27.0378 20.5361 27.1841 21.2679 27.183 22.0068C27.183 23.5086 26.5898 24.92 25.5202 25.9848Z"
                                  fill="black"
                                />
                              </svg>
                              setting
                            </div>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TopNav;
